import React from "react";
import { Navigate } from "react-router-dom";
import useWrapper from "../../hooks/useWrapper";

export default function FinancialRedirect() {
  const { permissions } = useWrapper();

  if (permissions?.financialGroup?.reading) return <Navigate to="/financial/billstoreceive" replace />;
  if (permissions?.financialCompany?.reading) return <Navigate to="/financial/billstopay" replace />;
  return <Navigate to="/no-permission" replace />;
}
